import { useTheme } from 'styled-components';
import config from '~/config';

const useContrastColor = () => {
  const { colors } = useTheme();
  return colors.$text.strong;
};

type Props = {
  height: number | string;
};

// recolor by providing your own fill css
export const PrimerLogo = ({ height }: Props) => {
  const color = useContrastColor();
  const src = `${config.VITE_PRIMER_CDN_URL}/image/primer/logo.svg`;
  return <img alt="Primer" height={height} src={src} style={{ fill: color }} />;
};

export const PrimerLogoIcon = () => {
  const theme = useTheme();
  const color = theme.colors.$text.strong;
  return (
    <img
      alt="Primer"
      height="43"
      src={`${config.VITE_PRIMER_CDN_URL}/image/primer/dots.svg`}
      style={{
        fill: color,
        filter: 'brightness(0) invert(1)', // converts black to white
      }}
      width="43"
    />
  );
};
